// main.jsx — Vite/React 入口
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/solpred.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
